module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Music-note-fa767f2504cf488ac3fdd737324a50e2.svg";